export default {
  zh: {
    i18nView: {
      title: '切换语言',
      note: '目前只翻译了当前页面和侧边栏和导航，未完待续，敬请期待...',
      datePlaceholder: '请选择日期',
      tableDate: '日期',
      tableName: '姓名',
      tableAddress: '地址',
      default: '默认按钮',
      primary: '主要按钮',
      success: '成功按钮',
      info: '信息按钮',
      warning: '警告按钮',
      danger: '危险按钮'
    }
  },
  en: {
    i18nView: {
      title: 'Switch Language',
      note:
        'Currently only translated the i18n page and the sidebar and levelbar, please look forword to...',
      datePlaceholder: 'Pick a day',
      tableDate: 'tableDate',
      tableName: 'tableName',
      tableAddress: 'tableAddress',
      default: 'default:',
      primary: 'primary',
      success: 'success',
      info: 'info',
      warning: 'warning',
      danger: 'danger'
    }
  }
}
